<template>
  <v-card>
    <v-card-text :style="'height: ' + contentHeight + 'px; overflow-y: auto;'">
      <v-tabs
      color="white"
      light
      name="sbTabPanel"
      v-model="tab2"
      ref="myTab"
      slider-color="#8ACAC1"
      @change="onChangeTab"
      class="activetab"
    >
      <v-tab name="tabTable" href="#tabTable">{{'TAB_VERFLECHTUNG_TABLE' | translate}}</v-tab>
      <v-tab name="tabHierachy" href="#tabHierachy" v-if="isBanks">{{'TAB_VERFLECHTUNG_HIERACHY' | translate}}</v-tab>
      <v-tab-item active value="tabTable" name="tabTable">
        <v-layout row wrap class="tableKDF smallerexpansion pt-2">
          <v-expansion-panel v-model="panel" expand>
            <v-expansion-panel-content flat>
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{titles[0]}}</div>

              </template>
              <div class="mx-2 pb-4">

                <StrukturBilanzTable :fixedHeight="fixedHeight1" :widthSub="40" :maxHeight="-1" :sortDisabled="true"
                                     :heightSub="0" ref="tableOwnershipDetails"
                                     tableName="tableOwnershipDetails" edoClassName="vf"></StrukturBilanzTable>
              </div>
            </v-expansion-panel-content>

            <v-expansion-panel-content flat>
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{titles[1]}}</div>

              </template>
              <div class="mx-2 pb-4">

                <StrukturBilanzTable :fixedHeight="fixedHeight2" :widthSub="40" :sortDisabled="true" :maxHeight="-1"
                                     :heightSub="0" ref="tableCorporateAction"
                                     tableName="tableCorporateAction" edoClassName="vf"
                                     myStyle="padding-top:0px;"></StrukturBilanzTable>
              </div>
            </v-expansion-panel-content>

            <v-expansion-panel-content flat>
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{titles[2]}}</div>

              </template>
              <div class="mx-2 pb-4">
                <StrukturBilanzTable :fixedHeight="fixedHeight3" :widthSub="40" :sortDisabled="true" :maxHeight="-1"
                                     :heightSub="0" ref="tableAlternateName"
                                     tableName="tableAlternateName" edoClassName="vf"
                                     myStyle="padding-top:0px;"></StrukturBilanzTable>
              </div>
            </v-expansion-panel-content>

            <v-expansion-panel-content flat>
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{titles[3]}}</div>

              </template>
              <div class="mx-2 pb-4">
                <StrukturBilanzTable :fixedHeight="fixedHeight4" :widthSub="40" :sortDisabled="true" :maxHeight="-1"
                                     :heightSub="0" ref="tableRegulatorDetails"
                                     tableName="tableRegulatorDetails" edoClassName="vf"
                                     myStyle="padding-top:0px;"></StrukturBilanzTable>
              </div>
            </v-expansion-panel-content>

            <v-expansion-panel-content flat>
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{titles[4]}}</div>

              </template>
              <div class="mx-2 pb-4">

                <StrukturBilanzTable :fixedHeight="fixedHeight5" :widthSub="40" :sortDisabled="true" :maxHeight="-1"
                                     :heightSub="0" ref="tableUltimateBeneficiary"
                                     tableName="tableUltimateBeneficiary" edoClassName="vf"
                                     myStyle="padding-top:0px;"></StrukturBilanzTable>
              </div>
            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-layout>
      </v-tab-item>
      <v-tab-item value="tabHierachy" name="tabHierachy" v-if="isBanks">
        <v-layout row wrap class="tableKDF smallerexpansion pt-2 expansionshadow">
          <v-flex xs12 class="tableKDF smallerexpansion pt-2">
            <v-expansion-panel v-model="panel" expand>
              <v-expansion-panel-content flat expand  v-if="hierachy && hierachy.ultimateParent">
                <template v-slot:header>
                  <span class="underline"></span>
                  <div>{{'TAB_VERFLECHTUNG_HEADER_ULTIMATE_MOTHER' | translate}}</div>
                </template>
                <v-layout row justify-start wrap>
                  <v-flex xs10>
                    <v-card class="text-xs-left" flat color="">
                      <v-layout row justify-center wrap v-if="hierachy.ultimateParent && hierachy.ultimateParent.crefoNr && hierachy.ultimateParent.crefoNr.length > 0">
                        <v-flex pa-1 pl-2 mb-4 class="verflechtungheadermother handpointer" @click="openCrefoNr(hierachy.ultimateParent.crefoNr)">{{hierachy.ultimateParent.name}}
                        </v-flex>
                      </v-layout>
                      <v-layout v-else row justify-center wrap>
                        <v-flex pa-1 pl-2 mb-4 class="verflechtungheadermother">{{hierachy.ultimateParent.name}}
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
              <v-expansion-panel-content flat expand v-if="hierachy && hierachy.owners && hierachy.owners.length > 0">
                <template v-slot:header>
                  <span class="underline"></span>
                  <div>{{'TAB_VERFLECHTUNG_HEADER_OWNER' | translate}}</div>
                </template>
                <v-layout row justify-start wrap>
                  <v-flex xs12 sm5>
                    <v-card class="text-xs-left tablehierachy" flat color="">
                      <v-data-table
                        :headers="headershierachy"
                        :items="hierachy.owners"
                        :pagination.sync="pagination"
                        hide-actions
                        class=""
                      >
                        <template v-slot:items="props">
                          <td>{{ props.item.name }}</td>
                          <td class="text-xs-right">
                            <span>{{ props.item.percentage }} %</span>
                            &nbsp;
                            <v-icon v-if="!(props.item.crefoNr && props.item.crefoNr.length > 0)" class="pl-3" small color="transparent">fa fa-external-link
                            </v-icon>
                            <v-icon @click="openItem(props.item)" v-if="props.item.crefoNr && props.item.crefoNr.length > 0" class="pl-3" small color="#8ACAC1">fa fa-external-link
                            </v-icon>
                          </td>
                        </template>
                      </v-data-table>
                      <!--<v-layout row justify-center wrap v-if="hierachy && hierachy.owners && hierachy.owners.length > 0">
                        <v-flex v-for="(owner,i) in hierachy.owners" :key="i" pa-1 pl-2 class="verflechtungheader">
                          <span  v-if="owner && owner.crefoNr && owner.crefoNr.length > 0" class="handpointer" @click="openCrefoNr(owner.crefoNr)">{{owner.name}}</span>
                          <span v-else>{{owner.name}}</span>
                        </v-flex>
                      </v-layout>-->
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
              <v-expansion-panel v-model="panel2" expand class="mt-3">
                <v-expansion-panel-content flat expand  v-if="hierachy && hierachy.ownerships && hierachy.ownerships.length > 0">
                  <template v-slot:header>
                    <span class="underline"></span>
                    <div>{{'TAB_VERFLECHTUNG_HEADER_HIERACHY' | translate}}</div>
                  </template>
                  <v-layout row justify-start>
                    <v-flex xs12 sm6 class="text-xs-left"><span class="bluetext subheading">{{sdTitle}}</span>
                    </v-flex>
                    <v-flex xs12 sm2 md2 class="text-xs-left">
                      <v-layout row>
                        <v-flex>
                          <v-select :items="sorts" v-model="sorted" @change="onChangeSort"
                                    :label="$t('LABEL_SORTING')"
                                    item-text="text"
                                    item-value="value">
                          </v-select>
                        </v-flex>
                        <v-flex>
                          <v-select v-model="deepValue"
                                    item-text="text"
                                    item-value="value"
                                    class="mx-1"
                                    @change="reload"
                                    :items="deepValues"
                                    :label="$t('LABEL_DEEP_VALUES')"
                          ></v-select>
                        </v-flex>
                      </v-layout>

                    </v-flex>
                    <v-flex xs12 sm2 md2 class="mx-5 mt-2">
                      <v-btn @click="openAll()" color="#004884" outline class="text-none mb-4">{{'BUTT_OPENALL' | translate}}</v-btn>
                    </v-flex>
                  </v-layout>
                    <v-layout row justify-start wrap v-if="hierachy">
                    <v-flex xs10 class="ml-5">
                      <v-treeview
                        :open.sync="opened"
                        @update:open="onOpen"
                        active-class="activetree"
                        :items="hierachy.ownerships"
                        hoverable
                        ref="treeview"
                        item-key="guid"
                      >
                        <template v-slot:label="{ item, open }">

                         <!-- <v-icon @click="openItem(item)" v-if="item.crefoNr && item.crefoNr.length > 0" class="mt-3" color="#8ACAC1">fa fa-external-link
                          </v-icon>-->
                          <div @click="openItem(item)" class="body-2 TextNav verflechtungtree" :style="'width:90%;border-bottom: dotted 1px #' + item.color + ';border-left: dotted 1px #' + item.color + ';'  + ';height: 40px;' + ';float:left;color:#'+ item.color + ';'  + ';padding-top: 8px;' + ';padding-left: 8px;'">
                            <div style="width: 50%;float:left">
                            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;overflow-wrap: break-word;">{{item.name | translate}}</div>
                            </div>
                            <span style="width: 30%"> {{item.percentage}} %</span>
                            <v-icon @click="openItem(item)" v-if="item.crefoNr && item.crefoNr.length > 0" class="pl-3" small color="#8ACAC1">fa fa-external-link
                            </v-icon>
                          </div>


                        </template>
                      </v-treeview>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
    </v-card-text>
  </v-card>
</template>
<script>
import Vue from 'vue'
import StrukturBilanzTable from './StrukturBilanzTable'
import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'

export default {
  name: 'TabVerflechtung',
  components: {StrukturBilanzTable, BtnDownloadExcel},
  props: ['balance', 'isPeergroup', 'balanceArray', 'sdTitle'],
  methods: {
    open: function () {
      Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
      this.reload()
    },
    close: function () {
      if (this.$refs['tableOwnershipDetails'] && this.$refs['tableOwnershipDetails'].close) this.$refs['tableOwnershipDetails'].close()
      if (this.$refs['tableCorporateAction'] && this.$refs['tableCorporateAction'].close) this.$refs['tableCorporateAction'].close()
      if (this.$refs['tableAlternateName'] && this.$refs['tableAlternateName'].close) this.$refs['tableAlternateName'].close()
      if (this.$refs['tableRegulatorDetails'] && this.$refs['tableRegulatorDetails'].close) this.$refs['tableRegulatorDetails'].close()
      if (this.$refs['tableUltimateBeneficiary'] && this.$refs['tableUltimateBeneficiary'].close) this.$refs['tableUltimateBeneficiary'].close()

    },
    openCrefoNr: function (crefoNr) {
      let defBalance = {
      }
      defBalance.crefoNr = crefoNr
      defBalance.rkNr = 0
      defBalance.source = 0
      defBalance.year = 0
      defBalance.aaNr = 0
      var url = '/Forward?url=' + Vue.prototype.$api.getStructureUrl(Vue.prototype.$api.getModuleId(), defBalance)
      Vue.prototype.$api.debug('url', url)
      this.$router.push({ path:url, meta: {
          forward: true
        }})
    },
    openItem: function (item) {
      console.log('openItem', item)
      if (!(item.crefoNr && item.crefoNr.length > 0)) {
        return
      }
      this.openCrefoNr(item.crefoNr)
    },
    onGetData: function (data) {
      Vue.prototype.$api.debug('Kennzahlen', data)
      this.tableData = data
      delete (this.tableData.table)
      this.titles = []
      var tIndex = 0
      for (var index in data.tables) {
        var t = data.tables[index]
        this.titles.push(t.name)

        let tHeight = t.rows.length * 40 + 70
        if (tHeight >= 500) {
          tHeight = 500
        }

        this['fixedHeight' + (tIndex + 1)] = tHeight
        tIndex++
      }

      Vue.prototype.$api.hideIdle()
      if (this.$refs['tableOwnershipDetails'] && this.$refs['tableOwnershipDetails'].open) this.$refs['tableOwnershipDetails'].open(data)
      if (this.$refs['tableCorporateAction'] && this.$refs['tableCorporateAction'].open) this.$refs['tableCorporateAction'].open(data)
      if (this.$refs['tableAlternateName'] && this.$refs['tableAlternateName'].open) this.$refs['tableAlternateName'].open(data)
      if (this.$refs['tableRegulatorDetails'] && this.$refs['tableRegulatorDetails'].open) this.$refs['tableRegulatorDetails'].open(data)
      if (this.$refs['tableUltimateBeneficiary'] && this.$refs['tableUltimateBeneficiary'].open) this.$refs['tableUltimateBeneficiary'].open(data)
      if (this.isBanks) {
        Vue.prototype.$api.createVerflechtungHierachyDataWithBalance(this.balance, this.deepValue, this.onGetDataHierachy)
      }
    },
    setChilds (childs, guid) {
      if (!childs) return guid
      for (var i = 0; i < childs.length; i++) {
        let item = childs[i]
        item.guid = guid
        guid = guid + 1
        guid = this.setChilds(item.children, guid)
      }
      return guid
    },
    onGetDataHierachy(hierachy) {
      console.log('onGetDataHierachy', hierachy)
      this.hierachy = hierachy
      this.sorted = 'name'
      Vue.prototype.storage.tabVFSorted = this.sorted
      let guid = 0
      let cmp = this
      if (this.hierachy.ownerships) {
        this.hierachy.ownerships = _.orderBy(this.hierachy.ownerships, ['name'], 'asc')
        let fIndx = -1
        _.each(this.hierachy.ownerships, function (v) {
          v.percentage = ('0' + v.percentage) * 1
          if (!v.finID || v.finID.length === 0) {
            v.finID = '' + fIndx
            fIndx = fIndx - 1
          }
          v.guid = guid
          guid = guid + 1
          guid = cmp.setChilds(v.children, guid)
        })
        // this.hierachy.ownerships = _.orderBy(this.hierachy.ownerships, ['percentage'], ['desc'])
        // console.log('onGetDataHierachy resulted ', this.hierachy.ownerships)
      }
    },
    onChangeTab(item) {
      Vue.prototype.$api.debug('onChangeTab', item, this.lastTab)
      if (this.lastTab) {
        if (this.$refs[item] && this.$refs[item].close) {
          Vue.prototype.$api.debug('close', item)
          this.$refs[item].close()
        }
      }
      if (this.$refs[item] && this.$refs[item].open) {
        Vue.prototype.$api.debug('open', item)
        this.$refs[item].open(this.tableData)
      }
      this.lastTab = item
    },
    reload: function () {
      this.isBanks = (Vue.prototype.$api.getModuleId() === 'banks')
      this.contentHeight = $('#pgMainDI').height() - 120
      Vue.prototype.$api.showIdle()
      if (this.isPeergroup) {
        Vue.prototype.$api.createVerflechtungDataWithBalanceArray(this.balanceArray, this.onGetData)
      } else {
        Vue.prototype.$api.createVerflechtungDataWithBalance(this.balance, this.onGetData)
      }
    },
    doResize () {
      let cmp = this
      window.setTimeout(function() {
        cmp.contentHeight = $('#pgMainDI').height() - 120
      }, 500)
    },
    onOpen(items) {
      this.opened = items
    },
    addChilds (childs) {
      if (!childs) return
      for (var i = 0; i < childs.length; i++) {
        let item = childs[i]
        this.opened.push(item.guid)
        this.addChilds(item.children)
      }
    },
    onChangeSort (sort) {
      console.log('onChangeSort', sort, this.sorted, this.sortRight)
      if (sort === 'percentage') {
        this.hierachy.ownerships = _.orderBy(this.hierachy.ownerships, ['percentage'], ['desc'])
        this.sortRight = this.sortRight * 1
      } else if (sort === 'name') {
        this.hierachy.ownerships = _.orderBy(this.hierachy.ownerships, ['name'], ['asc'])
      }
      Vue.prototype.storage.tabVFSorted = this.sorted
    },
    openAll () {
      if (this.opened && this.opened.length > 0) {
        this.opened = []
        return
      }
      this.opened = []
      for (var i = 0; i < this.hierachy.ownerships.length; i++) {
        let item = this.hierachy.ownerships[i]
        this.opened.push(item.guid)
        this.addChilds(item.children)
      }
    }
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 5000111,
        descending: true,
        sortBy: 'percentage'
      },
      deepValues: [{text: '1', value:1},
        {text: '2', value:2},
        {text: '3', value:3},
        {text: '4', value:4},
        {text: '5', value:5},
        {text: '6', value:6},
        {text: '7', value:7},
        {text: '8', value:8},
        {text: '9', value:9},
        {text: '10', value:10},
        {text: '11', value:11},
        {text: '12', value:12},
        {text: '13', value:13},
        {text: '14', value:14},
        {text: '15', value:15},
        {text: '-', value:99}
      ],
      deepValue: 8,
      headershierachy: [
        {
          text: Vue.i18n.translate('HIERACHY_NAME'),
          align: 'left',
          sortable: true,
          value: 'name',
          width: '70%',
        },
        { text: Vue.i18n.translate('HIERACHY_PERCENTAGE'), value: 'percentage', class: 'text-xs-right', align: 'right'}
      ],
      contenthierachy: [
        { name: ''},
        { percentage: ''}
  ],
      isBanks: false,
      sortRight: -1,
      panel: [true, true, true, true, true],
      panel2: [true, true, true, true, true],
      hierachy: null,
      sorted: 'percentage',
      sorts: [{
        text: Vue.i18n.translate('SORT_PERCENTAGE'),
        value: 'percentage'
      }, {
        text: Vue.i18n.translate('SORT_NAME'),
        value: 'name'
      }],
      opened: [],
      titles: [],
      contentHeight: 400,
      fixedHeight1: 100,
      fixedHeight2: 100,
      fixedHeight3: 100,
      fixedHeight4: 100,
      fixedHeight5: 100,
      configExcel: {
        excelSheetStammdaten: 0,
        excelSheetStrukturbilanz: 0,
        excelSheetRohbilanz: 0,
        excelSheetKennzahlen: 1,
        excelSheetBilanzrating: 0,
        excelSheetKDF: 0,
        excelSheetVerflechtungHierarchisch: 1,
        configName: '',
        type: 'EXCEL-STRUCT'
      },
      lastTab: 'tabTable',
      tab2: 'tabTable',
      tableData: null,
      tableHeightSub: 100
    }
  },
  mounted() {
    this.panel = [
      true, true, true, true, true
    ]
  },
  created() {

    Vue.prototype.$eventHub.$on('OnResize', this.doResize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('OnResize', this.doResize)

  }
}
</script>

<style scoped>
  .tableKDF .v-expansion-panel__header div {
    padding-bottom: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabVerflechtung.vue